<template>
  <section class="legal-widget">
    <div class="container">
      <h2>{{ $t('legal.title') }}</h2>
      <p class="description">{{ $t('legal.description') }}</p>
      <div class="grid">
        <div class="card">
          <h3>{{ $t('legal.pillar1.title') }}</h3>
          <p>{{ $t('legal.pillar1.description') }}</p>
        </div>
        <div class="card">
          <h3>{{ $t('legal.pillar2.title') }}</h3>
          <p>{{ $t('legal.pillar2.description') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.legal-widget {
  padding: 60px 20px;
  background-color: var(--gray-light);
  border-top: 1px solid var(--accent-light);
  border-bottom: 1px solid var(--accent-light);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

h2 {
  text-align: center;
  margin-bottom: 10px;
  color: var(--text-color);
}

.description {
  text-align: center;
  margin-bottom: 40px;
  opacity: 0.7;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.card {
  padding: 25px;
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.03);
  border: 1px solid var(--accent-light);
}

h3 {
  color: var(--primary-color);
  margin-bottom: 15px;
}

p {
  line-height: 1.5;
  color: var(--text-color);
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
